import styled from 'styled-components/macro';

export const SuccessModalContent = styled.div`
  width: 264px;
  margin: 26px auto;
  text-align: center;

  button img {
    position: absolute;
    top: 17px;
    right: 17px;
    width: 14px;
  }
`;
